import React from "react";

import EnglishQuizQuestion from "./EnglishQuizQuestion";

const EnglishQuizGroup = ({
  group,
  questions = [],
  answers = {},
  onAnswerChange,
}) => {
  if (!group) {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl shadow p-6">

      {/* Group Header */}

      {group.groupType && (
        <p className="text-sm font-semibold text-blue-600 uppercase">
          {group.groupType}
        </p>
      )}

      {/* Directions */}

      {group.directions && (
        <div className="mt-3 rounded-xl bg-gray-50 p-4">
          <p className="font-semibold text-gray-700">
            Directions
          </p>

          <p className="mt-1 text-gray-600 whitespace-pre-line">
            {group.directions}
          </p>
        </div>
      )}

      {/* Shared Content */}

      {group.sharedContent?.type !== "none" && (
        <div className="mt-5">

          {group.sharedContent?.text && (
            <div className="rounded-xl bg-blue-50 p-5">
              <p className="whitespace-pre-line text-gray-800">
                {group.sharedContent.text}
              </p>
            </div>
          )}

          {group.sharedContent?.imageUrl && (
            <div className="mt-4">
              <img
                src={group.sharedContent.imageUrl}
                alt="Question group"
                className="max-w-full rounded-xl"
              />
            </div>
          )}

        </div>
      )}

      {/* Questions */}

      <div className="mt-6 space-y-5">

        {questions.map((question, index) => (
          <EnglishQuizQuestion
            key={question._id}
            question={question}
            number={index + 1}
            selectedAnswer={
              answers[question._id] ?? null
            }
            onAnswerChange={onAnswerChange}
          />
        ))}

      </div>

    </div>
  );
};

export default EnglishQuizGroup;